import React from 'react';
import { Link } from 'react-router-dom';

const FeaturedCard = ({ item }) => {
  return (
    <Link
      to={item.linkUrl}
      target={item.externalLink ? '_blank' : ''}
      className="group flex h-full flex-col overflow-hidden  bg-[#ffffff] transition hover:no-underline"
    >
      <div className="aspect-[16/9] w-full overflow-hidden md:aspect-[16/9]">
        <img
          src={item.imageUrl}
          alt={item.header}
          className="h-full w-full object-cover transition duration-300 "
        />
      </div>
      <div className="py-5 sm:py-6 hover:no-underline">
        <h2
          className="text-3xl uppercase leading-none text-black sm:text-4xl"
          style={{ fontFamily: "Knockout Wide, sans-serif" }}
        >
          {item.header}
        </h2>
        <p
          className="mt-3 text-lg leading-snug text-black/90 sm:text-[1.1rem]"
          style={{ fontFamily: "Roboto, sans-serif" }}
        >
          {item.copy}
        </p>
      </div>
    </Link>
  );
};

export default FeaturedCard;